export default __webpack_public_path__ + "static/media/LAS0880.34I-39661_-23729_0.1e29231b.jpg";